
import { Component, OnInit, Input, ChangeDetectorRef, Injectable, ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@otas/modal/modal-ref';
import { NgbModal } from '@otas/modal/modal';
import { AppConstants } from 'app/app.constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
    template: `
  <div class="modal-header">
  <h5 class="modal-title" style="font-size: 16px;">
      <span class="fw-semi-bold">{{title}}</span>
  </h5>
  <button type="button" class="btn-close" aria-label="Close"
  (click)="activeModal.close(false)"></button>
</div>
<div class="modal-body">
  <span>{{content}}</span>
  <div class="mb-3" *ngIf="!!date">
  <label class="text-muted" for="large-rounded-input">{{dateTitle}}</label>
  <datetime   [datepicker]="datepickerOpts"   [timepicker]="false" [(ngModel)]="deleteDate"></datetime>
</div>

  <div class="mb-3" #parent2 *ngIf="!!reason">
  <label class="text-muted" for="large-rounded-input">{{'Reason'|translate}}</label>
  <indic-input [parentEl]="parent2"  tabindex="-1"
    [inputOptions]="{keyboardEnable:true,inputarea: 'textarea'}" [(ngModel)]="reasonForDelete"></indic-input>
    
</div>
</div>
<div class="modal-footer">
  <button *ngIf="!!cancelButton" type="button" class="btn btn-sm" aria-label="Close" (click)="activeModal.close(false)">Close</button>
  <button *ngIf="!!confirmButtonTitle || !!data" type="button" class="btn btn-danger btn-sm" aria-label="Confirm" (click)="close()">{{confirmButtonTitle}}</button>
  <button *ngIf="!!refundButton" type="button " class="btn btn-danger btn-sm" aria-label="Confirm" (click)="refund()">Refund</button>
  <button *ngIf="!!removeButton" type="button " class="btn btn-danger btn-sm" aria-label="Confirm" (click)="remove()">Remove</button>
  <button *ngIf="!!blockButton" type="button " class="btn btn-primary btn-sm" aria-label="Confirm" (click)="block()">Block Pooja</button>
  <button *ngIf="!!payment" type="button " class="btn btn-primary btn-sm" aria-label="Confirm" (click)="invoicePrint()">Print Voucher</button>
  <button *ngIf="!!invoice" type="button " class="btn btn-primary btn-sm" aria-label="Confirm" (click)="invoicePrint()">Print Invoice</button>
</div>
`,
    standalone: false
})
// tslint:disable-next-line:component-class-suffix
export class ConfirmModal implements OnInit {
  @Input() title;
  @Input() content;
  @Input() invoice;
  @Input() payment;
  @Input() confirmModal;
  @Input() button;
  @Input() date;
  @Input() endDate;
  @Input() cancelButton = true;
  @Input() removeButton;
  @Input() refundButton;
  @Input() blockButton;
  @Input() confirmButtonTitle;
  @Input() dateTitle;
  userData: any = {};
  deleteDate = new Date();
  reasonForDelete;
  data;
  datepickerOpts: any = AppConstants.datePickerOptions;
  @Input() reason;
  constructor(public activeModal: NgbActiveModal, private renderer: Renderer2,
    private el: ElementRef, public changeRef: ChangeDetectorRef, private cmService: ConfirmModalService) {
  }
  ngOnInit() {
    this.userData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
    if(this.userData.hasRefund=="true"){
    this.data=true;
    }
    else{
      this.data=false;
    }
    setTimeout(() => {
      const element = this.el.nativeElement.querySelectorAll('.date');
      element.forEach((el) => {
        this.renderer.addClass(el.children[0], 'form-control-sm');
        this.renderer.removeClass(el.parentElement, 'form-inline');
      });
    }, 0);

    this.datepickerOpts.startDate = new Date(this.date);
    this.datepickerOpts.endDate = !!this.endDate ? new Date(this.endDate) : null;
  }
  block() {
    this.activeModal.close({ reasonForDelete: this.reasonForDelete, status: 'blocked' });
  }
  refund()  {
    this.activeModal.close({ reasonForDelete: this.reasonForDelete, status: 'refunded' });
  }
  invoicePrint() {
    this.activeModal.close({ reasonForDelete: this.reasonForDelete, status: 'invoice' });
  }
  close() {
    if (!!this.reasonForDelete || !!this.date) {
      const obj = { reasonForDelete: this.reasonForDelete, refundDate: this.deleteDate, status: 'closed' };
      this.activeModal.close(obj);
    }
    else {
      this.activeModal.close(true);
    }

  }
  remove() {
    this.activeModal.close({ reasonForDelete: this.reasonForDelete, status: 'removed' });
  }
}

@Injectable()
export class ConfirmModalService {
  constructor(private modalService: NgbModal, private http: HttpClient) { }

  public confirm(title: string, content: string, removeButton?, button?, reason?, date?) {
    const modalRef = this.modalService.open(ConfirmModal, AppConstants.mediumModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.confirmButtonTitle = 'Confirm';
    modalRef.componentInstance.button = button;
    modalRef.componentInstance.reason = reason;
    modalRef.componentInstance.date = date;
    modalRef.componentInstance.changeRef.markForCheck();
    modalRef.componentInstance.removeButton = removeButton;
    return modalRef;
  }
  public confirmOnly(title: string, content: string, removeButton?, button?, reason?, date?) {
    const modalRef = this.modalService.open(ConfirmModal, AppConstants.mediumModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.confirmButtonTitle =null;
    modalRef.componentInstance.button = button;
    modalRef.componentInstance.reason = reason;
    modalRef.componentInstance.date = date;
    modalRef.componentInstance.changeRef.markForCheck();
    modalRef.componentInstance.removeButton = removeButton;
    return modalRef;
  }

  public _confirm(title: string, content: string, cancelButton?, confirmButtonTitle?: string, removeButton?, blockButton?, reason?, date?, endDate?, dateTitle?: string, invoice?) {
    const modalRef = this.modalService.open(ConfirmModal, AppConstants.mediumModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.confirmButtonTitle = !confirmButtonTitle ? 'Confirm' : confirmButtonTitle;
    modalRef.componentInstance.reason = reason;
    modalRef.componentInstance.date = date;
    modalRef.componentInstance.endDate = endDate;
    modalRef.componentInstance.changeRef.markForCheck();
    modalRef.componentInstance.cancelButton = cancelButton;
    modalRef.componentInstance.removeButton = removeButton;
    modalRef.componentInstance.blockButton = blockButton;
    modalRef.componentInstance.dateTitle = dateTitle;
    modalRef.componentInstance.invoice = invoice;
    return modalRef;
  }

  // public confirmDelete(title: string, content: string, removeButton?, refundButton?, blockButton?, reason?, date?) {
  //   const modalRef = this.modalService.open(ConfirmModal, AppConstants.mediumModalOptions);
  //   modalRef.componentInstance.title = title;
  //   modalRef.componentInstance.content = content;
  //   modalRef.componentInstance.refundButton = refundButton;
  //   modalRef.componentInstance.reason = reason;
  //   modalRef.componentInstance.date = date;
  //   modalRef.componentInstance.changeRef.markForCheck();
  //   modalRef.componentInstance.removeButton = removeButton;
  //   modalRef.componentInstance.blockButton = blockButton;
  //   return modalRef;
  // }

  public confirmInvoice(title: string, content: string, removeButton?, button?, invoice?) {
    const modalRef = this.modalService.open(ConfirmModal, AppConstants.mediumModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.button = button;
    modalRef.componentInstance.invoice = invoice;
    modalRef.componentInstance.changeRef.markForCheck();
    modalRef.componentInstance.removeButton = removeButton;
    return modalRef;
  }

  public confirmInvoiceOrPayment(title: string, content: string, invoice?, payment?) {
    const modalRef = this.modalService.open(ConfirmModal, AppConstants.mediumModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.confirmButtonTitle = null;
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.payment = payment;
    modalRef.componentInstance.invoice = invoice;
    modalRef.componentInstance.changeRef.markForCheck();
    return modalRef;
  }

  
}
